import React, { useState } from 'react';
const PageHeader = ({ title, description, videoSrc }) => {
  const [videoFailed, setVideoFailed] = useState(false);

  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-[#FFF8F5] via-[#F7F2EE] to-[#F7F2EE] py-16 md:py-24">
      {videoSrc && !videoFailed && (
        <video
          autoPlay
          muted
          loop
          playsInline
          preload="metadata"
          onError={() => setVideoFailed(true)}
          className="absolute inset-0 z-0 h-full w-full object-cover"
        >
          <source src={videoSrc} type="video/mp4" />
        </video>
      )}
      {videoSrc && videoFailed && (
        <div className="absolute inset-0 z-0 bg-gradient-to-br from-[#FFF8F5] via-[#F7F2EE] to-rose-100/70" aria-hidden="true" />
      )}
      {videoSrc && (
        <div className="pointer-events-none absolute inset-0 z-10 bg-gradient-to-b from-[#F7F2EE]/20 to-[#F7F2EE]/25" />
      )}
      <div className="pointer-events-none absolute -left-20 top-0 z-10 h-64 w-64 rounded-full bg-rose-200/35 blur-3xl" />
      <div className="pointer-events-none absolute -right-20 bottom-0 z-10 h-64 w-64 rounded-full bg-[#F5BCB1]/30 blur-3xl" />
      <div className="relative z-20 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <span className="mx-auto mb-6 block h-px w-20 bg-gradient-to-r from-transparent via-[#FB7185] to-transparent" aria-hidden="true" />
        <h1 className="font-serif text-4xl md:text-5xl font-semibold text-[#3A2A2A] mb-4">
          {title}
        </h1>
        {description && (
          <p className="text-lg text-stone-600 max-w-2xl mx-auto leading-relaxed">
            {description}
          </p>
        )}
      </div>
      <div className="section-divider-rose absolute bottom-0 left-0 right-0 z-30" aria-hidden="true" />
    </section>
  );
};

export default PageHeader;
